import { render, staticRenderFns } from "./ym-sales-customer.vue?vue&type=template&id=4b2f3a17&scoped=true&"
import script from "./ym-sales-customer.vue?vue&type=script&lang=js&"
export * from "./ym-sales-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2f3a17",
  null
  
)

export default component.exports